import SteddiInfoItem from "../../General/SteddiInfoItem";
import {Zap} from "lucide-react";
import React from "react";
import useOrderState from "../../../stores/orderStore";

export default function EnergiKonto() {
  const installations = useOrderState((state) => state.installations)

  return (
    <SteddiInfoItem title={"Adresse"} subtitle={<span style={{textTransform: "capitalize"}}>{installations.map(i => <span className="capitalize-word" key={i.meterPointId}><span>{i.address}, {i.zipCode}</span> <span>{i.postArea}</span><br/></span>)}</span>} color={"primary"} bgColor={"#B8FFEE"} icon={<Zap/>}/>
  )
}